import { useGetOrderDetailsQuery } from 'pages/orders/services';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import AddItemToOrderContainer from './container';
import { useMenuItems } from 'pages/dashboard/hooks/useMenuItems';

const AddItemToOrder = () => {
    const location = useLocation();
    const navigate = useNavigate();
     const { menuItems, categories, activeCategory, setActiveCategory, searchQuery, setSearchQuery,
        isFetchingItems, isLoading } = useMenuItems();

    const { data: orderDetails } = useGetOrderDetailsQuery(location?.state?.orderId,
                 { skip: !location?.state?.orderId });
    
  return (
    <AddItemToOrderContainer 
        orderDetails={orderDetails?.data}
        menuItems={menuItems}
        categories={categories}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        isFetchingItems={isFetchingItems}
        isLoading={isLoading}
    />
  )
}

export default AddItemToOrder
